import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';
import {MachineListViewUserConfig} from '@models/dashboard/machine-list/machine-list-view-user-config';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MachineListUserConfigApiService {
  private readonly MACHINE_LIST_USER_CONFIG_URL_SUFFIX = '/api/web/user/machineListConfig';
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient, apiLocationService: ApiLocationService) {
    this.baseUrl = apiLocationService.getLocation();
  }

  public get(): Observable<MachineListViewUserConfig> {
    return this.http.get<MachineListViewUserConfig>(
      this.baseUrl + this.MACHINE_LIST_USER_CONFIG_URL_SUFFIX,
      HTTPS_REQUEST_OPTIONS,
    );
  }

  public save(config: MachineListViewUserConfig): Observable<MachineListViewUserConfig> {
    return this.http.put<MachineListViewUserConfig>(
      this.baseUrl + this.MACHINE_LIST_USER_CONFIG_URL_SUFFIX,
      config,
      HTTPS_REQUEST_OPTIONS,
    );
  }
}
